import { useRef, useState, useEffect, useMemo } from 'react';
import FormCreator from '../../../components/Forms/FormCreator';
import CenterModel from '../../../components/ui/centerModel/CenterModel';
import { CertificateDateModelConfig } from '../data/CertificateDateModelConfig';
import Buttons from '../../../components/ui/button/Buttons';
import { useGenerateCertificateForIssuanceMutation } from '../../../app/services/CertificateGrouping/certificateGroupingApi';
import ToastService from '../../../services/toastService/ToastService';
import { useAddAuditLogForSGBPApplcation } from '../../../utils/AuditLogQuery/addAuditLog';

const IssueModel = ({ closeIssueModal, showIssueModal, rowData, fetchData }) => {
    const certificateIssuanceRef = useRef();
    const [formData, setFormData] = useState(CertificateDateModelConfig);
    const [generateCertificateForIssuance, { isLoading: generateCertificateForIssuanceLoading, isSuccess: generateCertificateForIssuanceSuccess, data: generateCertificateForIssuanceData, },] = useGenerateCertificateForIssuanceMutation();
    const { addAuditLog } = useAddAuditLogForSGBPApplcation();

    const applicationIds = useMemo(() => (
        rowData?.sgbpsApplicationId ?? "").toString().split(",").map((id) => id.trim()).filter(Boolean).map(Number),
        [rowData?.sgbpsApplicationId]);

    const handleSubmit = async (e) => {
        e?.preventDefault();
        const formData = certificateIssuanceRef?.current?.getFormData();
        if (formData && rowData?.templateId !== "") {
            let req = {
                sGBPSCertificateIssuanceTaskListId: rowData?.sgbpsCertificateIssuanceTaskListId ?? 0,
                sGBPSApplicationId: rowData?.sgbpsApplicationId ?? 0,
                sGBCCorporateMemberId: rowData?.sgbcCorporateMemberId ?? 0,
                issuanceStartDate: new Date(formData?.issuanceDate),
                issuanceEndDate: new Date(formData?.endDate),
                certificateTemplateId: rowData?.templateId ?? 0,
                groupingIds: rowData?.sgbpCertificateGroupingIds ?? ""
            }
            await generateCertificateForIssuance(req)
        }
    }

    useEffect(() => {
        if (!generateCertificateForIssuanceLoading && generateCertificateForIssuanceSuccess && generateCertificateForIssuanceData) {
            if (generateCertificateForIssuanceData) {
                ToastService.success(`The certificate has been issued for ${rowData?.certNumber}.`);
                // addAuditLog({
                //     SGBPSApplicationId: rowData?.sgbpsApplicationId,
                //     AuditLogDescription: `The certificate has been issued for ${rowData?.certNumber}.`,
                //     TriggredTimeStatusId: rowData?.sgbpsStatusId,
                // });
                applicationIds.forEach((appId) => {
                    addAuditLog({
                        SGBPSApplicationId: appId,
                        AuditLogDescription: `The certificate has been issued for ${appId}.`,
                        TriggredTimeStatusId: rowData?.sgbpsStatusId,
                    });
                });
                fetchData?.();
                closeIssueModal();

            } else {
                ToastService.error("something went wrong");
                closeIssueModal();
            }
        }
    }, [generateCertificateForIssuanceLoading, generateCertificateForIssuanceSuccess, generateCertificateForIssuanceData]);
    return (
        <CenterModel
            show={showIssueModal}
            handleClose={closeIssueModal}
            modelTitle="Issue"
            modelWidth="w-45"
        >
            <div className="d-flex justify-content-center gap-4">
                <FormCreator
                    ref={certificateIssuanceRef}
                    {...formData}
                />
            </div>
            <div className="d-flex justify-content-center mt-4">
                <Buttons
                    buttonText="Submit"
                    buttonTypeClassName="success-btn"
                    onClick={(e) => handleSubmit(e)}
                    isDisable={generateCertificateForIssuanceLoading}
                    isLoading={generateCertificateForIssuanceLoading}
                />
            </div>
        </CenterModel>
    )
}

export default IssueModel
